<template>
  <div class="bx-form__item bx-form__item--centered">
    <button class="bx-form__button bx-form__button--secondary"
            type="button"
            @click="$emit('reset-filters')">
      Filter zurücksetzen
    </button>
    <button class="bx-form__button"
            type="button"
            @click="$emit('apply-filters')">
      Filter anwenden
    </button>
  </div>
</template>
